import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const AdminGetStudentDoubts = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
        
           formData.append('course_url',payload.course_url);
           
           formData.append('user_id',payload.user_id);
           
           
           

           try{
               const res = await axios.post(ENDPOINT+"student-doubts.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default AdminGetStudentDoubts